import React from 'react';
import PDFEditor from './components/PDFEditor';
import './App.css';

function App() {
  return (
    <div className="app">
      <PDFEditor />
    </div>
  );
}

export default App;
